import { render, staticRenderFns } from "./AvatarFilter.vue?vue&type=template&id=5659ef3b"
import script from "./AvatarFilter.vue?vue&type=script&lang=js"
export * from "./AvatarFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports